import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HotelsState } from "../model";
import { HotelsStateFeatureKey } from "./hotels.reducer";

const hotelsFeatureSelector = createFeatureSelector<HotelsState>(
  HotelsStateFeatureKey
);

const getHotels = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.entities
);

const getFilterMetadata = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.filtersMetadata
);
const getActive = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.active
);
const getTotalRecordsLeft = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.totalRecordsLeft
);
const getTotalRecords = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.totalRecords
);
const getSelectedQuickFilter = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.selectedQuickFilter
);

const getLoadMoreActions = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.loadMoreActions
);

const getRequestMetadata = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.requestMetadata
);

const getSortValue = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.sort
);
const getLoading = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.loading
);

const getLoaded = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.loaded
);

const getErrors = createSelector(
  hotelsFeatureSelector,
  (state: HotelsState) => state?.error
);

const getHotelById = (id: number | string) =>
  createSelector(
    hotelsFeatureSelector,
    (state: HotelsState) => state?.entities[id]
  );

export const HotelsSelectors = {
  getHotels,
  getFilterMetadata,
  getActive,
  getTotalRecordsLeft,
  getTotalRecords,
  getSelectedQuickFilter,
  getLoadMoreActions,
  getRequestMetadata,
  getSortValue,
  getLoading,
  getLoaded,
  getErrors,
  getHotelById,
};
